module.exports = __webpack_public_path__ + "catalog/items/column-square/square_column.png";